import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CANCEL_INSURANCE_SERVICE_FOR_SHIPMENT,
  VIEW_PARCEL,
} from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { ICancelInsuranceRequest } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TCancelInsuranceForShipmentRequestDataUz } from "@/types/apiParam.types";
import { useTranslations } from "next-intl";

export const useCancelInsuranceForShipmentRequest = (): UseMutateAsyncFunction<
  AxiosResponse<{ data: ICancelInsuranceRequest }>,
  Error,
  TCancelInsuranceForShipmentRequestDataUz,
  unknown
> => {
  const queryClient = useQueryClient();
  const t = useTranslations();
  const { mutateAsync: cancelInsuranceRequest } = useMutation({
    mutationFn: (values: TCancelInsuranceForShipmentRequestDataUz) =>
      apiRequest(CANCEL_INSURANCE_SERVICE_FOR_SHIPMENT, "put", values),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [VIEW_PARCEL],
        exact: false,
      });
      toast.success(t("insurance_service_canceled"), {
        position: "top-center",
      });
    },
    onError: (error) => {
      toast.error(
        //@ts-ignore
        error?.response?.data?.error?.message || "Error occured",
        {
          position: "top-center",
        },
      );
    },
  });
  return cancelInsuranceRequest;
};
